<template>
    <router-link :to="`/users/${user.id}`">
        <div
            class="px-4 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150"
        >
            <div class="w-full flex items-center space-x-6 focus:outline-none">
                <div class="w-12 h-12 rounded-full border-4 border-gray-200 overflow-hidden">
                    <img
                        loading="lazy"
                        alt="user.lastName"
                        class="object-cover"
                        :src="parseUrl(user.photoURL)"
                    />
                </div>
                <div class="flex-1 flex items-center justify-between">
                    <div class="flex items-center space-x-4">
                        <h3 class="text-md font-normal ml-2">
                            {{ user.name }}
                        </h3>
                    </div>
                    <div class="flex space-x-8">
                        <div class="flex flex-col items-center">
                            <span class="text-xs">{{ $t('Givs Given') }}</span>
                            <span class="font-medium text-base">{{ user.givsGiven }}</span>
                        </div>
                        <div class="flex flex-col items-center">
                            <span class="text-xs">{{ $t('Givs Received') }}</span>
                            <span class="font-medium text-base">{{ user.givsReceived }}</span>
                        </div>
                        <div class="flex flex-col items-end">
                            <span class="text-xs uppercase">Last Login</span>
                            <span class="font-bold text-sm">{{ getDate }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import { formatDistanceToNow } from 'date-fns'
export default {
    props: ['user'],
    computed: {
        getDate() {
            if (!this.user.lastLoginAt) {
                return 'No Login'
            }
            return formatDistanceToNow(new Date(this.user.lastLoginAt), { addSuffix: true })
        },
    },
    methods: {
        parseUrl(url) {
            if (url.startsWith('http')) {
                return url
            }
            return `https://cdn.giv.link/${url}`
        },
    },
}
</script>
